module.exports = __webpack_public_path__ + "media/images/personnel/Lavar-Dopwell-af854c3fff3ecb51bcbfd2908fe88e8e.png";